import { upperFirst } from 'lodash'
import { usePathname } from 'next/navigation'
import { getTranslations } from './translations'
import { useLocalisation } from '@/tools/i18n/client'

export function useBreadcrumbs() {
  const { t, getLanguage } = useLocalisation()
  const language = getLanguage()
  const current = usePathname()

  const routeHistory = current.split('/').filter((x) => x?.length > 0)

  const breadcrumbRoutes = routeHistory.reduce((acc: { name: string; path: string }[], route) => {
    const previousPath = acc[acc.length - 1]?.path ?? ''

    if (route === language) {
      acc.push({ name: '', path: `${previousPath}/${route}` })
      return acc
    }
    const localizedBreadcrumbs = getTranslations(t).find((x) => x.name === route)?.key
    const routeName = upperFirst(localizedBreadcrumbs).replace('-', ' ')

    acc.push({ name: routeName, path: `${previousPath}/${route}` })
    return acc
  }, [])

  return { breadcrumbRoutes }
}
